import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import env from '@/services/environment'
import { isAuth } from './validations/AuthGuard'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'LoginSSO',
    component: () => import('@/views/loginSSO/index.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/pages/home/penaltyHomeMain/penaltyHomeMainComponent.vue')
  },
  {
    path: '/forbidden',
    name: 'ForbiddenAccess',
    component: () => import('../views/forbiddenAccess/index.vue')
  },
  {
    path: '/PenaltyMaster',
    name: 'PenaltyMaster',
    component: () => import('@/views/pages/home/penaltyHomeMain/penaltyHomeMainComponent.vue')
  },
  {
    path: '/penaltyCreate',
    name: 'PenaltyCreate',
    component: () => import('@/views/pages/home/penaltyCreatePenaltiesMain/penaltyCreatePenaltiesMainComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/PenaltyMaster',
    name: 'PenaltyMaster',
    component: () => import('@/views/pages/home/penaltyHomeMain/penaltyHomeMainComponent.vue')
  },
  // {
  //   path: '/CashPenaltyMaster',
  //   name: 'CashPenaltyMaster',
  //   component: () => import('@/views/pages/home/cashPenalty/cashPenalties/cashPenaltyMasterComponent.vue')
  // },
  {
    path: '/PenaltyManagementSearch',
    name: 'PenaltyManagementSearch',
    component: () => import('@/views/pages/penaltyManagement/penaltyManagementSearch/penaltyManagementSearchComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/poc',
    name: 'PocComponent',
    component: () => import('@/views/pages/pocComponent/PocComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/iframeindex',
    name: 'iframeindex',
    component: () => import('@/views/pages/franceLogin/FranceRedirectComponent.vue')
    // beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/penaltyGrid',
    name: 'PenaltyGrid',
    component: () => import('@/views/pages/penaltyGrid/PenaltyGridScreen.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/pages/administration/users/userSearch/userSearch.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/DocumentationSupplier',
    name: 'DocumentationSupplier',
    component: () => import('@/views/pages/documentation/supplier/documentationSupplierComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/DocumentationWarehouse',
    name: 'DocumentationWarehouse',
    component: () => import('@/views/pages/documentation/warehouse/documentationWarehouseComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/AdministrationSupplier',
    name: 'AdministrationSupplier',
    component: () => import('@/views/pages/administration/supplier/administrationSupplierComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/AdministrationWarehouse',
    name: 'AdministrationWarehouse',
    component: () => import('@/views/pages/administration/warehouse/administrationWarehouseComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/AdministrationCountry',
    name: 'AdministrationCountry',
    component: () => import('@/views/pages/administration/country/administrationCountryComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/permission',
    name: 'Permission',
    component: () => import('@/views/pages/administration/users/permissions/permissionComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/SlGridSearch',
    name: 'SlGridSearch',
    component: () => import('@/views/pages/administration/slGridSearch/slGridSearchComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/ProcessLoggerSearch',
    name: 'ProcessLoggerSearch',
    component: () => import('@/views/pages/administration/processLogger/processLoggerSearchComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/Parameters',
    name: 'Parameters',
    component: () => import('@/views/pages/parameters/parametersComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/Orders',
    name: 'Orders',
    component: () => import('@/views/pages/orderManagement/orderSearch/orderSearchComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  },
  {
    path: '/OrderManagementSearchSLP',
    name: 'OrderManagementSearchSLP',
    component: () => import('@/views/pages/orderManagement/orderFileUploadSLP/orderFileUploadSLPComponent.vue'),
    beforeEnter: (to, from, next) => { isAuth(to, from, next) }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: env.getEnvVariable('BASE_URL'),
  routes
})

export default router
